<div id="report-header" class="top-nav">
  <div class="container">
    <div class="row">
      <div class="col-3 col-lg-2 logo">
        <a [routerLink]="['/dashboard']">
          <img style="border: none;" src="../../../assets/icon/tchek-blue.svg" width="101px" height="27px" alt="">
        </a>
      </div>
      <div class="col-9 col-lg-10">
        <app-report-summary [report]='report' [reportId]="report?.id"></app-report-summary>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/report-header/report-header.component.html